<mat-card>
  <app-date-range (dateChanged)="refresh()"></app-date-range>
  <data-area [settings]="rangeArea"></data-area>

  <br />
  <h4>{{ settings.lang.deliveries }} {{ deliveries.totalRows }}</h4>
  <data-grid [settings]="deliveries" [height]="'400'"></data-grid>

  <h4>{{ settings.lang.volunteers }} {{ helperInfo.totalRows }}</h4>
  <data-grid [settings]="helperInfo" [height]="'400'"></data-grid>
</mat-card>
